import YouTubePlayer from 'youtube-player';

/* eslint-disable */

export default function initVideo() {
  const items = jQuery('.video-holder');

  if (!items.length) return;

  items.each(function () {
    const holder = jQuery(this);
    const $this = holder.find('[data-youtube]');
    const btnPlay = holder.find('.btn-play');

    const player = YouTubePlayer($this.attr('id'), {
      videoId: $this.data('youtube'),
      playerVars: {
        autoplay: 0,
      },
    });

    holder.data('player', player);

    player.on('stateChange', (event) => {
      holder.toggleClass('video-play', event.data != 4);
    });

    btnPlay.on('click', (e) => {
      e.preventDefault();
      player.playVideo();
    });
  });
}
